import React from 'react';

function Waste() {
  return (
    <div>
      <h1>Waste Component</h1>
    </div>
  );
}

export default Waste;   